"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentService = exports.OsType = exports.DeviceType = exports.BrowserFamily = void 0;
var BrowserFamily;
(function (BrowserFamily) {
    BrowserFamily["Android"] = "android";
    BrowserFamily["Chrome"] = "chrome";
    BrowserFamily["Edge"] = "edge";
    BrowserFamily["Firefox"] = "firefox";
    BrowserFamily["IE"] = "ie";
    BrowserFamily["Opera"] = "opera";
    BrowserFamily["Safari"] = "safari";
})(BrowserFamily = exports.BrowserFamily || (exports.BrowserFamily = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "desktop";
    DeviceType["Phone"] = "phone";
    DeviceType["Tablet"] = "tablet";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var OsType;
(function (OsType) {
    OsType["Android"] = "android";
    OsType["IOS"] = "ios";
    OsType["Macintosh"] = "macintosh";
    OsType["Other"] = "other";
    OsType["OtherMobile"] = "other-mobile";
    OsType["Windows"] = "windows";
})(OsType = exports.OsType || (exports.OsType = {}));
var EnvironmentService = /** @class */ (function () {
    function EnvironmentService(window) {
        this.hasOntouchstartEvent = 'ontouchstart' in window;
        this.hasTouchEvent = 'TouchEvent' in window;
        this.userAgent = window.navigator.userAgent;
        this.userAgentData = window.navigator.userAgentData;
        this.browser = this.detectBrowser();
        this.platform = this.detectPlatform();
        this.isNativeFullScreenSupported = [
            'fullscreenEnabled',
            'webkitFullscreenEnabled',
            'mozFullScreenEnabled',
            'msFullscreenEnabled',
        ].some(function (key) { return !!window.document[key]; });
        this.isMobile = this.platform.osType === OsType.IOS
            || this.platform.osType === OsType.Android
            || this.platform.osType === OsType.OtherMobile;
    }
    Object.defineProperty(EnvironmentService.prototype, "isTouchDevice", {
        get: function () {
            return this.hasOntouchstartEvent && this.hasTouchEvent;
        },
        enumerable: false,
        configurable: true
    });
    EnvironmentService.getWindowsVersion = function (userAgentVersion) {
        switch (userAgentVersion) {
            case 'NT':
                return 'NT';
            case 'XP':
                return 'XP';
            case 'NT 5.0':
                return '2000';
            case 'NT 5.1':
                return 'XP';
            case 'NT 5.2':
                return '2003';
            case 'NT 6.0':
                return 'Vista';
            case 'NT 6.1':
                return '7';
            case 'NT 6.2':
                return '8';
            case 'NT 6.3':
                return '8.1';
            case 'NT 10.0':
                return '10';
            default:
                return '';
        }
    };
    /**
     * Reads platformVersion from userAgentData (if supported)
     * For Windows, if it's not a Windows 11 it reurns value read in constructor from userAgent
     */
    EnvironmentService.prototype.getPlatformVersion = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, Promise, function () {
            var userAgent, platformVersion, majorPlatformVersion, majorPlatformVersion;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.userAgentData) {
                            return [2 /*return*/, ((_a = this.platform) === null || _a === void 0 ? void 0 : _a.osVersion) || ''];
                        }
                        return [4 /*yield*/, this.userAgentData.getHighEntropyValues(['platformVersion'])];
                    case 1:
                        userAgent = _e.sent();
                        if (!userAgent) {
                            return [2 /*return*/, ((_b = this.platform) === null || _b === void 0 ? void 0 : _b.osVersion) || ''];
                        }
                        platformVersion = userAgent.platformVersion || '';
                        // https://docs.microsoft.com/en-us/microsoft-edge/web-platform/how-to-detect-win11
                        // Once there will be Windows 12 this MUST be changed
                        if (userAgent.platform === 'Windows') {
                            majorPlatformVersion = +platformVersion.split('.')[0];
                            if (majorPlatformVersion >= 13) {
                                return [2 /*return*/, '11'];
                            }
                            return [2 /*return*/, ((_c = this.platform) === null || _c === void 0 ? void 0 : _c.osVersion) || ''];
                        }
                        if (userAgent.platform === 'macOS') {
                            majorPlatformVersion = platformVersion.split('.')[0];
                            if (+majorPlatformVersion >= 11) {
                                return [2 /*return*/, majorPlatformVersion];
                            }
                            return [2 /*return*/, platformVersion.split('.').slice(0, 2).join('.')];
                        }
                        if (platformVersion !== '') {
                            return [2 /*return*/, platformVersion];
                        }
                        return [2 /*return*/, ((_d = this.platform) === null || _d === void 0 ? void 0 : _d.osVersion) || ''];
                }
            });
        });
    };
    EnvironmentService.prototype.detectBrowser = function () {
        var versionIdentifier = this.getFirstMatch(/version\/(\d+(\.\d+)?)/i);
        var family;
        var version;
        if (/opr\/|opios|opera/i.test(this.userAgent)) {
            // new Opera
            family = BrowserFamily.Opera;
            if (/opera/i.test(this.userAgent)) {
                // old opera
                version = versionIdentifier || this.getFirstMatch(/(?:opera|opr|opios)[\s/](\d+(\.\d+)?)/i);
            }
            else {
                version = this.getFirstMatch(/(?:opr|opios)[\s/](\d+(\.\d+)?)/i) || versionIdentifier;
            }
        }
        else if (/windows phone/i.test(this.userAgent)) {
            //  windows phone
            var edgeVersion = this.getFirstMatch(/edge\/(\d+(\.\d+)?)/i);
            family = BrowserFamily.IE;
            if (edgeVersion) {
                family = BrowserFamily.Edge;
                version = edgeVersion;
            }
            else {
                version = this.getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
            }
        }
        else if (/msie|trident/i.test(this.userAgent)) {
            family = BrowserFamily.IE;
            version = this.getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i);
        }
        else if (/chrome.+? edge?/i.test(this.userAgent)) {
            family = BrowserFamily.Edge;
            version = this.getFirstMatch(/edge?\/(\d+(\.\d+)?)/i);
        }
        else if (/chrome|crios|crmo/i.test(this.userAgent)) {
            family = BrowserFamily.Chrome;
            version = this.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i);
        }
        else if (/firefox|iceweasel|fxios/i.test(this.userAgent)) {
            family = BrowserFamily.Firefox;
            version = this.getFirstMatch(/(?:firefox|iceweasel|fxios)[ /](\d+(\.\d+)?)/i);
        }
        else if (!/like android/i.test(this.userAgent) && /android/i.test(this.userAgent)) {
            family = BrowserFamily.Android;
            version = versionIdentifier;
        }
        else if (/safari|applewebkit/i.test(this.userAgent)) {
            family = BrowserFamily.Safari;
            version = versionIdentifier;
        }
        return {
            family: family,
            version: version,
        };
    };
    EnvironmentService.prototype.detectPlatform = function () {
        var windowsPhone = /windows phone/i.test(this.userAgent);
        var windows = !windowsPhone && /windows/i.test(this.userAgent);
        var ios = this.getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase();
        var android = !/like android/i.test(this.userAgent) && /android/i.test(this.userAgent);
        // regexes based on https://github.com/PoeHaH/devicedetector
        // we had to update them to match all user agents
        var isTablet = /(ipad|tablet|(nexus\s*(?:7|8|9|10))|(android(?!.*mobi))|(windows(?!.*phone)(?!.*wow64)(?!.*arm)(.*touch))|kindle|playbook|silk|(puffin(?!.*(ip|it|ap|wp))))/.test(this.userAgent.toLowerCase());
        var isPhone = /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin(?!.*(it))|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard|webos|dolfin)/.test(this.userAgent.toLowerCase());
        var deviceType = (isTablet && DeviceType.Tablet)
            || (isPhone && DeviceType.Phone)
            || DeviceType.Desktop;
        var osType;
        var osVersion;
        if (!windowsPhone && android) {
            osType = OsType.Android;
            osVersion = this.getFirstMatch(/android[ /-](\d+(\.\d+)*)/i);
        }
        else if (!ios && /macintosh/i.test(this.userAgent)) {
            osType = OsType.Macintosh;
            osVersion = this.getFirstMatch(/Mac OS X (\d+([_.\s]\d+)*)/i).replace(/[_\s]/g, '.');
            // detect iPad with Request Desktop Website enabled
            if (this.browser.family === BrowserFamily.Safari
                && this.hasTouchEvent) {
                deviceType = DeviceType.Tablet;
                osType = OsType.IOS;
            }
        }
        else if (!windowsPhone && ios) {
            osType = OsType.IOS;
            osVersion = this.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i).replace(/[_\s]/g, '.');
        }
        else if (windowsPhone) {
            osType = OsType.OtherMobile;
            osVersion = '';
        }
        else if (windows) {
            osType = OsType.Windows;
            osVersion = EnvironmentService.getWindowsVersion(this.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
        }
        else if (/blackberry|\bbb\d+/i.test(this.userAgent) || /rim\stablet/i.test(this.userAgent)) {
            osType = OsType.OtherMobile;
            osVersion = '';
        }
        else {
            osType = OsType.Other;
            osVersion = '';
        }
        return {
            deviceType: deviceType,
            osType: osType,
            osVersion: osVersion,
        };
    };
    EnvironmentService.prototype.getFirstMatch = function (regex) {
        var match = this.userAgent.match(regex);
        return (match && match[1]) || '';
    };
    return EnvironmentService;
}());
exports.EnvironmentService = EnvironmentService;
